export interface ToolItem {
  id: string;
  name: string;
  description: string;
  link: string;
  icon: string;
  status: "Active" | "Draft";
}

export const staticTools: ToolItem[] = [
  {
    id: "t_flower",
    name: "Flower Identifier",
    description: "Easily catalog wildflower varieties, bloom structures, and custom growth timelines.",
    link: "/tools/flower-identifier",
    icon: "Sparkles",
    status: "Active"
  },
  {
    id: "t_tree",
    name: "Trees Identifier",
    description: "Classify broadleaf & needle evergreen structures, trunk barks, and forest specimens.",
    link: "/tools/tree-identifier",
    icon: "Leaf",
    status: "Active"
  },
  {
    id: "t_weed",
    name: "Weeds & Shrub Identifier",
    description: "Identify invasive garden weeds, lawn grass types, and wild woody shrubs accurately.",
    link: "/tools/weed-identifier",
    icon: "Leaf",
    status: "Active"
  },
  {
    id: "t_disease",
    name: "Plant Disease Identifier",
    description: "Diagnose leaf spots, mold infections, black spots, and bacterial blight syndromes.",
    link: "/tools/disease-identifier",
    icon: "Activity",
    status: "Active"
  },
  {
    id: "t_water",
    name: "Watering Calculator",
    description: "Calculate custom irrigation cycles based on temperature, location, and soil types.",
    link: "/tools/watering-calculator",
    icon: "Droplets",
    status: "Active"
  },
  {
    id: "t_ph",
    name: "Soil pH Analyzer",
    description: "Learn how to diagnose and optimize soil acidity levels for standard house crops.",
    link: "/tools/soil-ph-analyzer",
    icon: "Filter",
    status: "Active"
  },
  {
    id: "t_sun",
    name: "Direct Sunlight Meter",
    description: "Determine daily light exposure thresholds for broadleaf indoor decorative items.",
    link: "/tools/sunlight-exposure-meter",
    icon: "Sun",
    status: "Active"
  },
  {
    id: "t_fertilizer",
    name: "Fertilization Planner",
    description: "Formulate healthy ratios of Nitrogen, Phosphorus, and Potassium for healthy foliage.",
    link: "/tools/fertilization-planner",
    icon: "Spade",
    status: "Active"
  }
];
